import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';
import { MealCreditDetailsSection } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/MealCreditDetailsSection';
import { MealCreditEditFormSection } from 'src/components/oneCorp/features/MealCredit/components/DetailsPage/MealCreditEditFormSection';
import { MealCreditPaths } from 'src/components/oneCorp/features/MealCredit/components/Routes/MealCreditPathsDictionary';

export interface MealCreditEditDetailsRoutesProps {
  corpId: string;
  mealCredit: IMealCredit;
  fetchMealCredit: () => Promise<void>;
}

export function MealCreditEditDetailsRoutes({
  corpId,
  mealCredit,
  fetchMealCredit,
}: MealCreditEditDetailsRoutesProps): JSX.Element {
  return (
    <Switch>
      <Route
        path={MealCreditPaths.edit}
        render={() => (
          <MealCreditEditFormSection
            mealCredit={mealCredit}
            corpId={corpId}
            fetchMealCredit={fetchMealCredit}
          />
        )}
      />

      <Route
        path={MealCreditPaths.details}
        render={() => (
          <MealCreditDetailsSection corpId={corpId} mealCredit={mealCredit} />
        )}
      />
    </Switch>
  );
}
